import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, catchError, of, switchMap } from "rxjs";
import { JornalService } from "src/app/services/jornal.service";
import { listarEdicoesCalendario, listarEdicoesCalendarioSuccess } from "../../actions/Jornal/listar-edicoes-para-calendario.action";

@Injectable()
export class ListarEdicoesCalendarioEffects {

  public listarEdicoesCalendario$: unknown;

  constructor(private actions$: Actions,
    private listarEdicoesCalendarioService: JornalService) {
    this.createEffects()
  }

  private createEffects() {
    this.listarEdicoesCalendario$ = createEffect(() => this.actions$.pipe(
      ofType(listarEdicoesCalendario),
      switchMap(({ listarEdicoesCalendarioInputDto }) =>
        this.listarEdicoesCalendarioService.ListarEdicoesParaCalendario(listarEdicoesCalendarioInputDto)
        .pipe(map(response => {
          return listarEdicoesCalendarioSuccess({ response });
        }),
          catchError(() => of())
        )
      )
    )
    );
  }
}
